import React, { useContext } from 'react';
import { Spinner, Tab } from 'react-bootstrap';
import { ChatContext } from 'context/Context';
import ChatContentHeader from './ChatContentHeader';
import ChatContentBody from './ChatContentBody';
import MessageTextArea from './MessageTextArea';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ChatContent = ({ setHideSidebar }) => {
  const { conversations, conversation, activeConversationId, isLoading } =
    useContext(ChatContext);
  return isLoading ? (
    <div className="d-flex justify-content-center align-items-center w-100">
      <Spinner animation="border" variant="primary" />
    </div>
  ) : conversation ? (
    <Tab.Content className="card-chat-content">
      {conversations.map((thread, index) =>
        conversation?.id === thread.id ? (
          <Tab.Pane
            key={index}
            eventKey={thread.id}
            className="card-chat-pane"
            unmountOnExit
          >
            <ChatContentHeader
              setHideSidebar={setHideSidebar}
              conversation={conversation}
            />
            <ChatContentBody conversation={conversation} />
          </Tab.Pane>
        ) : null
      )}
      <MessageTextArea />
    </Tab.Content>
  ) : !activeConversationId || !conversations.length ? (
    <div className="card-chat-pane w-100 d-flex flex-column h-100">
      <div className="chat-content-header" style={{ height: 68 }}>
        <div
          className="pe-3 text-700 d-md-none contacts-list-show cursor-pointer"
          onClick={() => setHideSidebar(false)}
        >
          <FontAwesomeIcon icon="chevron-left" />
        </div>
      </div>
      <div
        className="d-flex justify-content-center align-items-center w-100 p-3"
        style={{ flexGrow: 1 }}
      >
        <h3 className="text-center">
          {!conversations.length
            ? 'No hay conversaciones'
            : 'Selecciona una conversación'}
        </h3>
      </div>

      <MessageTextArea />
    </div>
  ) : null;
};

ChatContent.propTypes = {
  setHideSidebar: PropTypes.func.isRequired
};

export default ChatContent;
